import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AuthenticationService, DataService } from "../../shared";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthenticationService, private ds: DataService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (localStorage.getItem("IsAuthenticated_" + environment.AppName)) {
      var l = localStorage.getItem("LocationId_" + environment.AppName)
      var b = localStorage.getItem("BranchId_" + environment.AppName)
      var c = localStorage.getItem("CompanyId_" + environment.AppName)
      if (Number(l) == 0 || Number(b) == 0 || Number(c) == 0) {
        this.router.navigate(["/app"]);
        return false;
      }
      this.auth.setAccessToken(localStorage.getItem("Access_Token_" + environment.AppName));
      this.ds.CheckAndLoadSettings();
      return true;
    }
    this.router.navigate(["/login"]);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/+core/guards/auth.guard.ts